import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from './ui/card';
import { Switch } from './ui/switch';
import { Label } from './ui/label';
import { useTheme } from '../hooks/useTheme';
import { SunIcon, MoonIcon } from '@heroicons/react/24/outline';

const DisplaySettings: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <SunIcon className="h-5 w-5" />
          Display Settings
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        {/* Dark Mode Toggle */}
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="dark-mode" className="text-base">
              Dark Mode
            </Label>
            <p className="text-sm text-muted-foreground">
              Switch between light and dark themes
            </p>
          </div>
          <div className="flex items-center gap-2">
            <SunIcon className="h-4 w-4 text-muted-foreground" />
            <Switch
              id="dark-mode"
              checked={theme === 'dark'}
              onCheckedChange={toggleTheme}
            />
            <MoonIcon className="h-4 w-4 text-muted-foreground" />
          </div>
        </div>

        {/* Theme Preview */}
        <div className="rounded-lg border p-4 bg-muted/50">
          <h4 className="text-sm font-medium mb-2">Theme Preview</h4>
          <div className="space-y-2">
            <div className="h-3 bg-primary rounded w-3/4"></div>
            <div className="h-3 bg-secondary rounded w-1/2"></div>
            <div className="h-3 bg-muted rounded w-2/3"></div>
          </div>
          <p className="text-xs text-muted-foreground mt-2">
            Current theme: <span className="font-medium capitalize">{theme}</span>
          </p>
        </div>

        {/* Additional Display Options */}
        <div className="space-y-4">
          <h4 className="text-sm font-medium">Additional Options</h4>
          
          {/* Font Size */}
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label htmlFor="font-size" className="text-sm">
                Font Size
              </Label>
              <p className="text-xs text-muted-foreground">
                Adjust the size of text throughout the application
              </p>
            </div>
            <select 
              id="font-size"
              className="rounded-md border border-input bg-background px-3 py-1 text-sm"
              defaultValue="medium"
            >
              <option value="small">Small</option>
              <option value="medium">Medium</option>
              <option value="large">Large</option>
            </select>
          </div>

          {/* Compact Mode */}
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label htmlFor="compact-mode" className="text-sm">
                Compact Mode
              </Label>
              <p className="text-xs text-muted-foreground">
                Reduce spacing for a more compact interface
              </p>
            </div>
            <Switch id="compact-mode" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default DisplaySettings;
